import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';
import React from 'react';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const ExplanationBlock = ({
  titleTranslatedContent,
  explanation,
}: {
  explanation: string;
  titleTranslatedContent: TranslatedContent;
}) => {
  const language = useLanguage();

  return (
    <>
      <div className={'flex flex-col gap-2 px-8 pt-6 pb-8'}>
        <S2Typography
          variant={'headline-6-alt'}
          textColorVariant={'gray-900'}
          translatedContent={titleTranslatedContent}
        />
        <S2Typography
          variant={'body-6'}
          textColorVariant={'gray-900'}
          translatedContent={language.textWithNewlines({
            text: explanation,
          })}
        />
      </div>
      <div className={'h-[1px] bg-gray-200'} />
    </>
  );
};
